import React, { memo } from 'react'
import dynamic from 'next/dynamic'
import { FormattedMessage, useIntl } from 'react-intl'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid2'
import FaqCard from 'components/FaqsPage/FaqCard'
import size from 'lodash/size'
import { addIdProp, addTestIdProp } from 'utils/universal'
import gsx from 'styles'
import sx from './styles'

const CardSectionDynamic = dynamic(() => import('components/FaqsPage/CardSection'))
const ContactDynamic = dynamic(() => import('components/shared/Contact'))

const Faqs = (props) => {
  const { formatMessage: f } = useIntl()
  const {
    data = [],
    title,
    titleProps = { variant: 'h3' },
    variant = 'column',
    showContactUs = false,
    variantPhone = 'sales', // sales || shopping
    variantWhatsappPhone = 'sales-your-car',
    sx: sxProps = {},
    showSubtitleContact = true,
    testId: testIdProp,
    faqSectionProps,
    showPhones = true,
    customNumberPhone,
    showFaqs = false,
  } = props
  const paddingColumn = variant === 'column' ? gsx.rightContainerItems : size(sxProps) > 0 ? sxProps : sx.root

  const faqSection = {
    title: 'COMMON_FAQS_NOT_FOUND',
    button: {
      text: 'COMMON_FAQS_TEXT_BUTTON',
      href: 'ROUTE_FAQS',
    },
  }

  return (
    <Container
      sx={paddingColumn}
      {...addTestIdProp(testIdProp)}
      {...addIdProp(testIdProp)}
    >
      <Grid container>
        {title && (
          <Grid size={12}>
            <Typography
              sx={sx.title}
              {...titleProps}
            >
              <FormattedMessage id={title} />
            </Typography>
          </Grid>
        )}
        <Grid
          size={12}
          container
          spacing={variant === 'column' ? 0 : 2}
        >
          {data.map((item, index) => (
            <Grid
              sx={sx.gridItem}
              key={`faq-${index}`}
              size={{
                xs: 12,
                lg: variant === 'column' ? 12 : 6,
              }}
              mt={(variant === 'column' && index > 0) ? 2 : 0}
            >
              <FaqCard
                key={index}
                item={item}
              />
            </Grid>
          ))}

          {showContactUs && (
            <>

              {showFaqs && (
                <Grid
                  sx={sx.gridItem}
                  size={{
                    xs: 12,
                    lg: variant === 'column' ? 12 : 6,
                  }}
                >
                  <CardSectionDynamic
                    title={faqSectionProps?.title || faqSection.title}
                    button={faqSectionProps?.button || faqSection.button}
                    sx={sx.customCardBtn}
                  />
                </Grid>
              )}

              {showPhones && (
                <Grid
                  size={{
                    xs: 12,
                    lg: variant === 'column' ? 12 : 6,
                  }}
                >
                  <ContactDynamic
                    titleVariant="h4"
                    titleComponent="h4"
                    sx={sx.contactContainer}
                    title="HOME_DO_YOU_HAVE_ANY_COMMENTS"
                    description="HOME_CONTACT_US_FOR_WHATSAPP_OR_CALL_US"
                    showInfo={false}
                    showSubtitle={showSubtitleContact}
                    variantPhone={variantPhone}
                    variantWhatsappPhone={variantWhatsappPhone}
                    whatsappMessage={f({ id: 'HOME_WHATSAPP_HOME_WELCOME_MESSAGE' })}
                    customNumberPhone={customNumberPhone}
                  />
                </Grid>
              )}

            </>
          )}

        </Grid>
      </Grid>
    </Container>
  )
}

export default memo(Faqs)
